import TickIcon from '../icons/tick-icon/TickIcon.vue'
import Plus from 'components/icons/plus/Plus.vue'

export default {
  props: {
    style: {
      type: Object,
      required: true
    },
    sku: {
      type: Object,
      required: true
    },
    family: {
      type: Object,
      required: true
    }
  },
  components: {
    TickIcon,
    Plus
  },
  setup(_, { emit }) {
    /**
     * @param {string} familyId
     * @param {string} styleId
     */
    function updateAddFont(familyId, styleId) {
      emit('onUpdateAddFont', {
        familyId,
        styleId
      })
    }

    /**
     * @param {Object} family
     * @param {string} styleId
     * @param {Object} style
     */
    function addFontToBundle(family, skuId, style) {
      emit('onAddFontToBundle', {
        family,
        skuId,
        style
      })
    }

    return {
      updateAddFont,
      addFontToBundle
    }
  }
}
